import {
  API_AGENT_LIST,
  API_AGENT_TRANSACTION_LIST,
  API_AGENT_UPDATE,
  API_AGENTS_BALANCE,
  API_USERS_DEFAULT_DELETE,
  API_USERS_DEFAULT_UPDATE,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const getAgentsListAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_AGENT_LIST,
  });
};
export const editAgentDefaultWalletAPI = ({ id, currencies }) => {
  let postData = {
    id,
    currencies,
  };
  return axiosMiddleware({
    method: "patch",
    url: API_USERS_DEFAULT_UPDATE,
    data: postData,
  });
};
export const deleteDefaultWalletAPI = ({ id }) => {
  let postData = {
    id,
  };
  return axiosMiddleware({
    method: "delete",
    url: API_USERS_DEFAULT_DELETE,
    data: postData,
  });
};
export const getAgentTransactionsAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_AGENT_TRANSACTION_LIST}?limit=${limit}&&offset=${offset}`,
    // data: postData,
  });
};

export const getAgentsBalancesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_AGENTS_BALANCE,
  });
};

export const updateAgentAPI = ({ agentId, updatedStatus }) => {
  let postData = {
    agentId,
    updatedStatus,
  };

  return axiosMiddleware({
    method: "post",
    url: API_AGENT_UPDATE,
    data: postData,
  });
};
